import { enviarAlNavegadorDelSistema } from './navegadorExterno';
import { esApp } from './plataforma';

/** Una pestaña que se abre antes de saber a dónde va. */
export interface PestanaPendiente {
	irA: (url: string) => void;
	/** Para cuando al final no hay a dónde ir. */
	cerrar: () => void;
}

/**
 * Reservar una pestaña AHORA para llevarla a una dirección que se conocerá después.
 *
 * En el navegador hay que abrirla dentro del gesto del usuario —si no, el bloqueador de ventanas la
 * para—, así que se abre en blanco y se redirige cuando llega la dirección.
 *
 * Dentro de la app eso no vale: en iOS una pestaña en blanco no se llega a abrir y en Android se
 * carga encima de la propia app. Tampoco vale abrirla después con `window.open`: para entonces el
 * toque del usuario ya ha caducado y iOS, fuera de un toque, no abre ventanas (devuelve `null`). Se
 * espera a tener la dirección y se NAVEGA a ella: Capacitor atiende en los dos sistemas cualquier
 * navegación a una dirección de fuera mandándola al navegador del sistema, y la app se queda donde
 * estaba.
 */
export const abrirPestanaPendiente = (): PestanaPendiente => {
	if (esApp()) {
		return { irA: enviarAlNavegadorDelSistema, cerrar: () => undefined };
	}

	const ventana = window.open('about:blank', '_blank');

	return {
		irA: (url) => {
			if (!ventana) {
				return;
			}
			// Cortar el vínculo con nuestra pestaña antes de salir a una web externa (reverse
			// tabnabbing). `about:blank` es del mismo origen, así que aquí sí se puede anular.
			ventana.opener = null;
			ventana.location.href = url;
		},
		cerrar: () => ventana?.close()
	};
};
